export default "__VITE_ASSET__rwcXroMh__"